// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__lIwJE","circle":"Spinner_circle__ywIhv","spinner":"Spinner_spinner__+LmNQ"};